import Papa from 'papaparse';

emptyValue = (value, callback, field) ->
  if (value.length > 0)
    callback(true)
  else
    alert(field + ' is a required field')
    callback(false)

read_workbook = (workbook) ->
  result = []
  workbook.SheetNames.forEach((sheetName) ->
    sheet = workbook.Sheets[sheetName]
    if !!sheet['!ref']
      ref = sheet['!ref'].split(":")
      first_name_identifier = 'A'#ref[0].match(/[A-Z]*/)[0]
      last_name_identifier = "B"#ref[1].match(/[A-Z]*/)[0]
      job_identifier = "C"#ref[2].match(/[A-Z]*/)[0]
      department_identifier = "D"#ref[3].match(/[A-Z]*/)[0]
      description_identifier = "E"#ref[4].match(/[A-Z]*/)[0]
      phone_identifier = "F"#ref[5].match(/[A-Z]*/)[0]
      email_identifier = "G"#ref[6].match(/[A-Z]*/)[0]
      twitter_identifier = "H"#ref[7].match(/[A-Z]*/)[0]
      linkedin_identifier = "I"#ref[8].match(/[A-Z]*/)[0]
      facebook_identifier = "J"#ref[9].match(/[A-Z]*/)[0]
      instagram_identifier = "K"#ref[10].match(/[A-Z]*/)[0]

      range_start = 2 #parseInt(ref[0].match(/[0-9]*$/)[0])
      range_end = parseInt(ref[1].match(/[0-9]*$/)[0])

      while range_start <= range_end
        result.push({
          first_name:   sheet["#{first_name_identifier}#{range_start}"]   && sheet["#{first_name_identifier}#{range_start}"].v  || '',
          last_name:    sheet["#{last_name_identifier}#{range_start}"]    && sheet["#{last_name_identifier}#{range_start}"].v   || '',
          job_title:    sheet["#{job_identifier}#{range_start}"]          && sheet["#{job_identifier}#{range_start}"].v         || '',
          department:   sheet["#{department_identifier}#{range_start}"]   && sheet["#{department_identifier}#{range_start}"].v  || '',
          description:  sheet["#{description_identifier}#{range_start}"]  && sheet["#{description_identifier}#{range_start}"].v || '',
          phone_number: sheet["#{phone_identifier}#{range_start}"]        && sheet["#{phone_identifier}#{range_start}"].v       || '',
          email:        sheet["#{email_identifier}#{range_start}"]        && sheet["#{email_identifier}#{range_start}"].v       || '',
          twitter:      sheet["#{twitter_identifier}#{range_start}"]      && sheet["#{twitter_identifier}#{range_start}"].v     || '',
          linkedin:     sheet["#{linkedin_identifier}#{range_start}"]     && sheet["#{linkedin_identifier}#{range_start}"].v    || '',
          facebook:     sheet["#{facebook_identifier}#{range_start}"]     && sheet["#{facebook_identifier}#{range_start}"].v    || '',
          instagram:    sheet["#{instagram_identifier}#{range_start}"]    && sheet["#{instagram_identifier}#{range_start}"].v   || '',
        })

        range_start = range_start + 1
  )
  return result

$("#people_to_import").change (e) ->
  add_list = null
  file = null
  reader = null
  add_list = $(this)
  file = $(this)[0].files[0]
  colHeaders = ['First name', 'Last name', 'Job title', 'Department', 'Description', 'Phone number', 'Email', 'Twitter ID',
                'LinkedIn URL', 'Facebook URL', 'Instagram username']
  if file
    reader = new FileReader()
    file_type = null
    file_name_parts = file.name.split(".")
    if file_name_parts[file_name_parts.length - 1] == "csv"
      reader.readAsText(file)
      file_type = 'csv'
    else
      if file_name_parts[file_name_parts.length - 1] == "xlsx"
        reader.readAsArrayBuffer(file)
        file_type = "xlsx"
      else
        if file_name_parts[file_name_parts.length - 1] == "xls"
          reader.readAsArrayBuffer(file)
          file_type = "xls"

    unless !!file_type
      alert("Please select a CSV or Excel (xlsx) file.")
      e.preventDefault()
      $(this).val("")
      return
    else
      $("input[type='submit']").show()

    reader.onload = (ee) ->
      imported_people_data = []
      switch file_type
        when 'csv'
          words_data = Papa.parse(ee.target.result, {}).data
          for word in words_data
            imported_people_data.push({
              first_name: word[0],
              last_name: word[1],
              job_title: word[2],
              department: word[3],
              description: word[4],
              phone_number: word[5],
              email: word[6],
              twitter: word[7],
              linkedin: word[8],
              facebook: word[9],
              instagram: word[10],
            })
        when 'xlsx'
          binary = ""
          bytes = new Uint8Array(ee.target.result)
          length = bytes.byteLength;
          i = 0
          while i < length
            binary += String.fromCharCode(bytes[i])
            i = i + 1

          temp1 = XLSX.read(binary, {type: 'binary'})
          imported_people_data = read_workbook(temp1)
        when 'xls'
          binary = ""
          bytes = new Uint8Array(ee.target.result)
          length = bytes.byteLength;
          i = 0
          while i < length
            binary += String.fromCharCode(bytes[i])
            i = i + 1
          temp1 = XLS.parse_xlscfb(XLS.CFB.read(binary, {type: 'binary'}))
          imported_people_data = read_workbook(temp1)
        else
          alert("Please use either Excel or CSV file")
          return

      index = 1
      indices = []
      container = document.getElementById('people_preview');
      $(container).show()
      $(container).find('table tbody').html('')

      imported_people_data.forEach((item) ->
        $('#people-import-form').append("<input type='file' name='people_image[#{index}]' id='people_image_#{index}' class='display-none'>")
        $('#people-import-form').append("<input type='hidden' name='people_images_data[#{index}]' id='people_images_data_#{index}' class='display-none'>")
        $(container).find('table tbody').append("<tr><td>#{item.first_name}</td><td>#{item.last_name}</td><td class='import-people-image'><a href='#' class='#{index} people_image person-avatar-round'><img class='display-none people_image_preview' src=''></img></a><i class='fa fa-plus-circle'></i></td></tr>")
        indices.push index
        index++
      )

      $('#people').val(JSON.stringify(imported_people_data))

      $('.people_image').click ->
        col = $(this)
        id = $(this).attr('class').split(' ')[0]
        $("#people_image_#{id}").click()

        $("#people_image_#{id}").off 'change', ->
          # unbinding change callback

        $("#people_image_#{id}").on 'change', ->
          file = $("#people_image_#{id}")[0].files[0]
          if file
            reader = new FileReader()
            reader.onload = (e) ->
              image_base64 = e.target.result
              $(col).find('img').attr "src", image_base64
              $(col).find('img').show()
              image_data = {
                image: image_base64.replace(/^data:image\/(png|jpeg);base64,/, ""),
                type: file.type,
                name: file.name
              }
              $("#people_images_data_#{id}").val(JSON.stringify(image_data))
            reader.readAsDataURL file
